// Added "JS is enabled and basic classList method works" class
document.body.classList.add('js');

// Toggles noscroll state of body
function noscrollToggle() {
    document.body.classList.toggle('noscroll');
}

// Smooth scrolling to anchor: scrolls the target element into view smoothly at the top
function scrollToTarget(targetElement) {
    if (targetElement) {
        targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}

// Handles checkbox checking when an anchor is wrapped by a label
function handleCheckbox(parentLabel) {
    if (parentLabel && parentLabel.getAttribute('for') !== '') {
        const checkboxId = parentLabel.getAttribute('for');
        const checkbox = document.getElementById(checkboxId);
        if (checkbox) {
            checkbox.checked = true;
        }
    }
}

// Handles click on any anchor with an href starting with '#' (except defined exceptions)
// This function performs smooth scrolling to the target element and moves focus there with preventScroll.
function scrollToAnchor(event) {
    // Get the closest anchor element (in case a nested element was clicked)
    const link = event.target.closest('a');
    if (!link) return;

    const hrefAttribute = link.getAttribute('href');

    // Handle skip-links for mobile menus: if handled, return.
    if (handleSkipLinkMenu(event, hrefAttribute)) return;

    if (
        hrefAttribute &&
        hrefAttribute.startsWith('#') &&
        hrefAttribute !== '#' &&
        !['#tab1', '#tab2', '#tab3', '#tab4', '#filterToggleBox'].includes(hrefAttribute)
    ) {
        event.preventDefault();
        const targetElement = document.querySelector(hrefAttribute);
        if (targetElement) {
            // Execute smooth scroll to the target element
            scrollToTarget(targetElement);

            // After a slight delay, move focus to the target element without causing an additional scroll
            setTimeout(() => {
                targetElement.focus({
                    preventScroll: true
                });
            }, 100);
        }

        // If the link is inside a label, handle the checkbox (if applicable)
        const parentLabel = link.closest('label');
        if (parentLabel) {
            handleCheckbox(parentLabel);
        }
    }
}

// Attach the scrollToAnchor function to all click events on the document
document.addEventListener('click', event => {
    scrollToAnchor(event);
});


// Image captions
/*document.addEventListener('DOMContentLoaded', function() {
    const pictureCaptions = document.querySelectorAll('img.picture-caption');

    pictureCaptions.forEach(img => {
        if (img.hasAttribute('alt')) {
            const captionText = img.getAttribute('alt'),
                captionWidth = img.width,
                figureClass = img.getAttribute('class');
            img.removeAttribute('class');
            const figure = document.createElement('figure');
            figure.className = figureClass;
            img.parentNode.insertBefore(figure, img);
            figure.appendChild(img);
            figure.insertAdjacentHTML('beforeend', `<figcaption>${captionText}</figcaption>`);
            img.nextElementSibling.style.width = `${captionWidth}px`;
            img.setAttribute('alt', '');
        }

        img.addEventListener('load', function() {
            if (img.hasAttribute('alt')) {
                const captionWidth = img.width;
                const figCaption = img.nextElementSibling;
                if (figCaption) {
                    figCaption.style.width = `${captionWidth}px`;
                }
            }
        });
    });

    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const pictureCaptions = document.querySelectorAll('.picture-caption img');
            pictureCaptions.forEach(img => {
                if (img.hasAttribute('alt')) {
                    const figCaption = img.nextElementSibling;
                    if (figCaption) {
                        figCaption.style.width = '0';
                        const captionWidth = img.width;
                        figCaption.style.width = `${captionWidth}px`;
                    }
                }
            });
        }, 100);
    });
});*/
document.addEventListener('DOMContentLoaded', function() {
    const imgs = document.querySelectorAll('img.picture-caption');

    imgs.forEach(img => {
        if (!img.hasAttribute('alt')) return;

        const captionText = img.getAttribute('alt');
        const imgClasses = img.getAttribute('class');
        img.removeAttribute('class'); // remove class from IMG

        const figure = document.createElement('figure');
        figure.className = imgClasses; // assign to FIGURE

        // pokud je parent picture → přeneseme celý picture
        const parent = img.parentNode;
        if (parent.tagName.toLowerCase() === 'picture') {
            parent.parentNode.insertBefore(figure, parent);
            figure.appendChild(parent);
        } else {
            parent.insertBefore(figure, img);
            figure.appendChild(img);
        }

        const figc = document.createElement('figcaption');
        figc.textContent = captionText;
        figure.appendChild(figc);

        img.setAttribute('alt','');
    });

    function updateCaptionWidths() {
        document.querySelectorAll('figure.picture-caption img').forEach(img => {
            const rect = img.getBoundingClientRect();
            const figCaption = img.nextElementSibling;
            if (figCaption) figCaption.style.width = rect.width + 'px';
        });
    }

    // první výpočet
    updateCaptionWidths();

    // se zpožděním jako původně
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateCaptionWidths, 100);
    });
});




// Tooltips for abbreviations
function tooltipAbbr() {
    document.querySelectorAll('abbr[title]').forEach(abbrElement => {
        const title = abbrElement.getAttribute('title');

        if (title) {
            abbrElement.classList.add('tooltip');
            abbrElement.innerHTML += `<span class="tooltip__txt">${title}</span>`;
            abbrElement.setAttribute('title', '');
        }
    });
}
document.addEventListener('DOMContentLoaded', tooltipAbbr);


// Tooltip control – call on DOMContentLoaded and after some AJAX loads
function tooltipControl() {
  const tooltips = document.querySelectorAll('.tooltip');

  tooltips.forEach(tooltip => {
    // skip already initialized elements
    if (tooltip.classList.contains('no-css-hover')) return;
    tooltip.classList.add('no-css-hover');

    // set up ARIA and keyboard focus
    tooltip.setAttribute('role', 'button');
    tooltip.setAttribute('aria-haspopup', 'dialog');
    tooltip.setAttribute('aria-expanded', 'false');
    tooltip.setAttribute('aria-labelledby', 'sr-label-tooltip');
    tooltip.setAttribute('aria-describedby', 'sr-descr-tooltip');
    tooltip.tabIndex = 0;

    // announce tooltip text politely when it appears
    const textRegion = tooltip.querySelector('.tooltip__txt');
    if (textRegion) {
      textRegion.setAttribute('role', 'dialog');
      textRegion.setAttribute('aria-modal', 'false');
      textRegion.setAttribute('aria-live', 'polite');
    }

    // remove links from tab order until tooltip is sticky
    updateLinksTabIndex(tooltip, -1);

    // hover: show and hide tooltip
    tooltip.addEventListener('mouseover', () => activate(tooltip));
    tooltip.addEventListener('mouseout',  () => deactivate(tooltip));

    // disable double-tap zoom on iOS and prevent label focus-steal on touchstart
    // (necessary to get consistent two-tap toggle on iOS)
    tooltip.style.touchAction = 'manipulation';
    tooltip.addEventListener('touchstart', e => {
      if (e.target.closest('label')) e.preventDefault();
    }, { passive: false });

    // toggle sticky state on click (mouse) AND touchend (touch) – both are bound,
    // so hybrid devices (touchscreen laptops, DevTools device mode) work as well
    const onToggle = event => {
      if (event.target !== event.currentTarget) return;
      if (event.type === 'touchend') {
        // suppress emulated mouseover/click that follow the tap → no double toggle
        event.preventDefault();
      } else if (event.target.closest('label')) {
        event.preventDefault();
      }
      event.stopPropagation();
      // keep focus on the tooltip (iOS does not focus on tap), but without the focus ring
      tooltip.focus({ preventScroll: true, focusVisible: false });
      toggleStick(tooltip);
    };
    tooltip.addEventListener('click', onToggle);
    tooltip.addEventListener('touchend', onToggle);

    // keyboard activation (Enter or Space) – only on the tooltip itself, not on links inside it
    tooltip.addEventListener('keydown', event => {
      if (event.target !== event.currentTarget) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleStick(tooltip);
      }
    });
  });

  // close sticky tooltips on Escape (once)
  if (!tooltipControl.escListenerAdded) {
    document.addEventListener('keydown', globalEscapeHandler);
    tooltipControl.escListenerAdded = true;
  }

  // close sticky tooltips on outside click or when opening another (once)
  if (!tooltipControl.clickOutsideAdded) {
    document.addEventListener('click', outsideClickHandler);
    tooltipControl.clickOutsideAdded = true;
  }

  // close sticky tooltips other than the given one (only one tooltip visible at a time)
  function closeOtherSticky(tooltip) {
    document.querySelectorAll('.tooltip.stick').forEach(other => {
      if (other !== tooltip) {
        other.classList.remove('stick');
        updateAriaExpanded(other, false);
        updateLinksTabIndex(other, -1);
      }
    });
  }

  // show tooltip on hover (and close any other sticky tooltip)
  function activate(tooltip) {
    closeOtherSticky(tooltip);
    tooltip.classList.add('active');
    updateAriaExpanded(tooltip, true);
    tooltipReposition();
  }

  // hide tooltip after hover, unless it is sticky
  function deactivate(tooltip) {
    tooltip.classList.remove('active');
    if (!tooltip.classList.contains('stick')) {
      updateAriaExpanded(tooltip, false);
    }
  }

  // toggle sticky state and ensure only one is open
  function toggleStick(tooltip) {
    // close any other sticky tooltips
    closeOtherSticky(tooltip);

    // toggle this tooltip
    const nowSticky = tooltip.classList.toggle('stick');
    tooltip.classList.remove('active');
    updateAriaExpanded(tooltip, nowSticky);
    updateLinksTabIndex(tooltip, nowSticky ? 0 : -1);
    tooltipReposition();
  }

  // set aria-expanded state
  function updateAriaExpanded(tooltip, expanded) {
    tooltip.setAttribute('aria-expanded', expanded);
  }

  // close all sticky tooltips on Escape
  function globalEscapeHandler(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tooltip.stick').forEach(t => {
      t.classList.remove('stick');
      updateAriaExpanded(t, false);
      updateLinksTabIndex(t, -1);
    });
  }

  // close sticky tooltips on click outside or when clicking another tooltip
  function outsideClickHandler(event) {
    const clicked = event.target.closest('.tooltip');
    document.querySelectorAll('.tooltip.stick').forEach(t => {
      if (t === clicked) return;
      t.classList.remove('stick');
      updateAriaExpanded(t, false);
      updateLinksTabIndex(t, -1);
    });
  }

  // enable or disable tab stops for links in the tooltip text
  function updateLinksTabIndex(tooltip, index) {
    tooltip.querySelectorAll('.tooltip__txt a')
           .forEach(link => link.tabIndex = index);
  }
}

// initialize on page load
document.addEventListener('DOMContentLoaded', tooltipControl);

// Tooltips repositioning
function tooltipReposition() {
    document.querySelectorAll('.tooltip').forEach(tooltip => {
        const offsetTooltip = tooltip.getBoundingClientRect();

        if (offsetTooltip) {
            if (offsetTooltip.left < 240) {
                const tooltipTxt = tooltip.querySelector('.tooltip__txt');
                if (tooltipTxt) {
                    tooltipTxt.style.right = 'auto';
                    tooltipTxt.style.left = (-1) * offsetTooltip.left + 5 + 'px';
                }
            } else {
                const tooltipTxt = tooltip.querySelector('.tooltip__txt');
                if (tooltipTxt) {
                    tooltipTxt.style.right = '0';
                    tooltipTxt.style.left = 'auto';
                }
            }
        }
    });
}


// Toggles visibility of objects according to navButtons clicks
function controlNavButton(navButton, toggleObject, fnBefore, fnAfter, toggleOutside) {
    var navButton = document.querySelector(navButton),
        toggleObject = document.querySelector(toggleObject);

    if (!navButton || !toggleObject) {
        return false;
    }

    var toggleObjectFn = function(event) {
        event.preventDefault();
        if (fnBefore) {
            if (typeof window[fnBefore] === 'function') {
                window[fnBefore]();
            } else {
                console.log('Unknown function "' + fnBefore + '" could not be processed.');
            }
        }

        toggleObject.classList.toggle('is-visible');

        if (toggleObject.classList.contains('is-visible')) {
            toggleObject.focus();
        } else {
            navButton.focus();
        }

        if (toggleOutside) {
            var clickOutsideHandler = function(event) {
                if (!toggleObject.contains(event.target) || event.target === closeButton) {
                    toggleObject.classList.remove('is-visible');
                    document.removeEventListener('click', clickOutsideHandler);
                }
            };

            if (toggleObject.classList.contains('is-visible')) {
                document.addEventListener('click', clickOutsideHandler);
            }
        }

        if (fnAfter) {
            if (typeof window[fnAfter] === 'function') {
                window[fnAfter]();
            } else {
                console.log('Unknown function "' + fnAfter + '" could not be processed.');
            }
        }

        event.stopPropagation();
    }

    navButton.addEventListener('click', toggleObjectFn);

    var closeButton = toggleObject.querySelector('.expander-close');

    if (closeButton) {
        closeButton.addEventListener('click', toggleObjectFn);
    }
}
var afterSearchBoxShow = function() {
    const search = document.getElementById('search');
    search.focus();
    // window.addEventListener('resize', searchBoxIsVisibleDesktopRemove); // Caused terrible issues on mobile Android (Chrome probably)
}

function searchBoxIsVisibleDesktopRemove() {
    const mq = window.matchMedia('(min-width: 1200px)');
    const searchBox = document.getElementById('search-box');
    if (searchBox && !mq.matches) {
        searchBox.classList.remove('is-visible');
    }
}

controlNavButton('#menu-show', '.menu-box', 'mobileMenuManagement', '', false);
controlNavButton('.tree-section', '.tree-box', 'mobileTreeManagement', '', false);
controlNavButton('#search__icon', '#search-box', 'removeSearchHighlight', 'afterSearchBoxShow', true);
controlNavButton('#login-expander', '#header-login', '', '', true);
controlNavButton('#logged-login-link', '#header-logged', '', '', true);


// Opens the specified container via skip-link on mobile devices.
function openSkipLinkMenu(boxId, toggleSelector) {
    const menuContainer = document.getElementById(boxId);
    if (!menuContainer) return;

    if (!menuContainer.classList.contains("is-visible")) {
        const toggleButton = document.querySelector(toggleSelector);
        toggleButton && toggleButton.click();
    }

    setTimeout(() => menuContainer.focus({
        preventScroll: true
    }), 100);
}

// Opens the main menu via skip-link.
function openMainMenuViaSkipLink() {
    openSkipLinkMenu('menu-box', '#menu-show');
}

// Opens the tree menu via skip-link.
function openTreeMenuViaSkipLink() {
    openSkipLinkMenu('tree-box', '.tree-section');
}

// Opens the search box via skip-link.
function openSearchBoxViaSkipLink() {
    openSkipLinkMenu('search-box', '#search__icon');
}


// Handles skip-link for menus (mobile only)
function handleSkipLinkMenu(event, hrefAttribute) {
    const openFunctions = {
        '#menu-box': openMainMenuViaSkipLink,
        '#tree-box': openTreeMenuViaSkipLink,
        '#search-box': openSearchBoxViaSkipLink
    };

    if (openFunctions[hrefAttribute]) {
        let mq;
        if (hrefAttribute === '#search-box') {
            mq = window.matchMedia('screen and (min-width: 1200px)');
        } else {
            mq = window.matchMedia('screen and (min-width: 900px)');
        }
        if (!mq.matches) {
            event.preventDefault();
            openFunctions[hrefAttribute]();
            return true; // signal that we handled the event
        }
    }
    return false;
}


// Setup ARIA attributes and keyboard toggle for sublist expanders
function setupSublistExpanders() {
    document.querySelectorAll('.sublist__expander').forEach(expander => {
        expander.setAttribute('tabindex', '0');
        expander.setAttribute('role', 'button');
        if (!expander.hasAttribute('aria-expanded')) {
            expander.setAttribute('aria-expanded', 'false');
        }
        expander.addEventListener('click', () => {
            const current = expander.getAttribute('aria-expanded');
            expander.setAttribute('aria-expanded', current === 'true' ? 'false' : 'true');
        });
        expander.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 32) {
                e.preventDefault();
                expander.click();
            }
        });
    });
}

// Returns all visible menu links within .menu-list.
function getVisibleMenuLinks() {
    return Array.from(document.querySelectorAll('.menu-list a')).filter(link => link.offsetParent !== null);
}

// Checks if a menu link is a first-level item.
function isFirstLevelItem(link) {
    const li = link.closest('li');
    return li && li.parentElement && li.parentElement.classList.contains('menu-list');
}

// Checks if a menu link is in a submenu.
function isSecondLevelItem(link) {
    return !isFirstLevelItem(link);
}

// For a first-level item, open its submenu if it's closed.
function handleArrowRight(link) {
    if (!isFirstLevelItem(link)) return;
    const li = link.closest('li');
    if (!li) return;
    const submenu = li.querySelector('ul.menu-sublist');
    const expander = li.querySelector('.sublist__expander');
    if (submenu && expander) {
        const style = window.getComputedStyle(submenu);
        if (style.display === 'none' || style.visibility === 'hidden') {
            expander.click();
        }
    }
}

// Closes submenu: for second-level items, collapse parent submenu and refocus parent link;
// for first-level, if submenu is open, collapse it.
function handleArrowLeft(link) {
    const li = link.closest('li');
    if (!li) return;
    if (isSecondLevelItem(link)) {
        const parentLi = li.closest('.menu-list li');
        if (parentLi) {
            const expander = parentLi.querySelector('.sublist__expander');
            const submenu = parentLi.querySelector('ul.menu-sublist');
            if (submenu && expander) {
                const style = window.getComputedStyle(submenu);
                if (!(style.display === 'none' || style.visibility === 'hidden')) {
                    expander.click();
                    const parentLink = parentLi.querySelector('a');
                    if (parentLink) {
                        setTimeout(() => {
                            parentLink.focus({
                                preventScroll: true
                            });
                        }, 50);
                    }
                }
            }
        }
    } else if (isFirstLevelItem(link)) {
        const expander = li.querySelector('.sublist__expander');
        const submenu = li.querySelector('ul.menu-sublist');
        if (submenu && expander) {
            const style = window.getComputedStyle(submenu);
            if (!(style.display === 'none' || style.visibility === 'hidden')) {
                expander.click();
            }
        }
    }
}

// Focus next visible menu link without wrapping.
function focusNextVisibleItem(current) {
    const visibleLinks = getVisibleMenuLinks();
    const index = visibleLinks.indexOf(current);
    if (index > -1 && index < visibleLinks.length - 1) {
        visibleLinks[index + 1].focus();
    }
}

// Focus previous visible menu link without wrapping.
function focusPreviousVisibleItem(current) {
    const visibleLinks = getVisibleMenuLinks();
    const index = visibleLinks.indexOf(current);
    if (index > 0) {
        visibleLinks[index - 1].focus();
    }
}

// Setup keyboard navigation for mobile menu (viewport < 900px)
function setupMobileMenuKeyboardNavigation() {
    const mq = window.matchMedia('screen and (max-width: 899px)');
    if (!mq.matches) return;

    setupSublistExpanders();
    const menuList = document.getElementById('menu-box');
    if (!menuList) return;

    menuList.addEventListener('keydown', e => {
        const key = e.key;
        const current = document.activeElement;
        if (!menuList.contains(current)) return;
        switch (key) {
            case 'ArrowDown':
                e.preventDefault();
                focusNextVisibleItem(current);
                break;
            case 'ArrowUp':
                e.preventDefault();
                focusPreviousVisibleItem(current);
                break;
            case 'ArrowRight':
                e.preventDefault();
                handleArrowRight(current);
                break;
            case 'ArrowLeft':
                e.preventDefault();
                handleArrowLeft(current);
                break;
            default:
                break;
        }
    });
}


// Closes mobile menu (dummy implementation).
function closeMobileMenu() {
    const closeBtn = document.querySelector('.menu-box__header .expander-close');
    const focusBtn = document.querySelector('#menu-show');
    if (closeBtn) closeBtn.click();
    if (focusBtn) focusBtn.focus();
}

// Closes tree menu (dummy implementation).
function closeMobileTree() {
    const closeBtn = document.querySelector('.tree-box__header .expander-close');
    const focusBtn = document.querySelector('.tree-section');
    if (closeBtn) closeBtn.click();
    if (focusBtn) focusBtn.focus();
}

// Closes search box (dummy implementation).
function closeMobileSearch() {
    const closeBtn = document.querySelector('.search-box .expander-close');
    const focusBtn = document.querySelector('#search__icon');
    if (closeBtn) closeBtn.click();
    if (focusBtn) focusBtn.focus();
}

// Closes login box (dummy implementation).
function closeLoginBox() {
    const closeBtn = document.querySelector('.login-box .expander-close');
    const focusBtn = document.querySelector('#login-expander');
    if (closeBtn) closeBtn.click();
    if (focusBtn) focusBtn.focus();
}

// Closes logged box (dummy implementation).
function closeLoggedBox() {
    const closeBtn = document.querySelector('.logged-box .expander-close');
    const focusBtn = document.querySelector('#logged-login-link');
    if (closeBtn) closeBtn.click();
    if (focusBtn) focusBtn.focus();
}


// Global Escape key handler to close menu box.
document.addEventListener('keydown', e => {
    if (e.key === 'Escape' || e.keyCode === 27) {
        const menuBox = document.querySelector('.menu-box.is-visible');
        const treeBox = document.querySelector('.tree-box.is-visible');
        const searchBox = document.querySelector('.search-box.is-visible');
        const headerLogin = document.querySelector('.header-login.is-visible');
        const headerLogged = document.querySelector('.header-logged.is-visible');

        if (menuBox) {
            e.preventDefault();
            closeMobileMenu();
            return;
        }
        if (treeBox) {
            e.preventDefault();
            closeMobileTree();
            return;
        }
        if (searchBox) {
            e.preventDefault();
            closeMobileSearch();
            return;
        }

        if (headerLogin) {
            e.preventDefault();
            closeLoginBox();
            return;
        }

        if (headerLogged) {
            e.preventDefault();
            closeLoggedBox();
            return;
        }
    }
});


// Close the mobile box when focus leaves items inside as a result of Tab navigation.
function setupTabLeaveHandler(containerSelector, closeFunction) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    container.addEventListener('keydown', e => {
        if (e.key === 'Tab' || e.keyCode === 9) {
            setTimeout(() => {
                // Pokud viewport není desktopový a focus již nepatří do containeru, zavři menu.
                if (!window.matchMedia('(min-width: 900px)').matches && !container.contains(document.activeElement)) {
                    closeFunction();
                }
            }, 0);
        }
    });
}

setupMobileMenuKeyboardNavigation();
setupTabLeaveHandler('.menu-list', closeMobileMenu);
setupTabLeaveHandler('.nav-tree', closeMobileTree);
setupTabLeaveHandler('#search-box-form', closeMobileSearch);


// Removes highlight and hint classes when coming from error page
function controlSearchHints() {
    const search = document.getElementById('search');
    if (search) {
        search.addEventListener('focus', function(e) {
            const searchIcon = document.querySelector('.search__icon');
            const searchItems = document.querySelector('.search-items');
            if (searchIcon) {
                searchIcon.classList.remove('highlight');
            }
            if (searchItems) {
                searchItems.classList.remove('highlight');
            }
        }, {
            once: true
        });
        search.addEventListener('input', function(e) {
            const hintSearchbox = document.querySelector('.hint--searchbox');
            if (hintSearchbox) {
                hintSearchbox.classList.remove('hint');
            }
        }, {
            once: true
        });
    }
}
controlSearchHints();


// Marks links pointing outside the website
function outboundLinks() {
    const html = document.querySelector('html');
    const lang = html.getAttribute('lang');

    const outboundLinkTitle = lang === 'en' ? 'Outbound link' : 'Odkaz směřuje mimo tento web';
    const outboundLinkExclusions = [
        '[href^="/"]',
        '[href*="tyma.cz"]',
        '[href*="tyma.eu"]',
        '[href^="#"]',
        '[href^="mailto:"]',
        '[href^="tel:"]',
        '[href^="javascript:"]',
        '.no-outbound-marks',
        '.more-filter',
        '.less-filter'
    ];
    const outboundLinkSelector = 'a[href^="//"],a' + outboundLinkExclusions.map(s => ':not(' + s + ')').join('');
    const outboundLinkIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.842 21.842"><g stroke-width="2"><path style="isolation:auto;mix-blend-mode:normal;solid-color:#000;solid-opacity:1" color="#000" overflow="visible" fill="#fff" stroke-linecap="round" d="M1 5h15.842v15.842H1z"/><path d="M20.842 1h-6" fill="none" fill-rule="evenodd" stroke-linecap="square"/><path d="M16.5 5.342L20.842 1" fill="none" fill-rule="evenodd"/><path d="M20.842 1v6" fill="none" fill-rule="evenodd" stroke-linecap="square"/></g></svg>';

    document.querySelectorAll(outboundLinkSelector).forEach(link => {
        const existingTitle = link.getAttribute('title') || '';
        const newLine = existingTitle !== '' ? '\n' : '';
        link.setAttribute('title', existingTitle + newLine + outboundLinkTitle);
        link.classList.add('outbound-link');

        if (!link.querySelector('img')) {
            link.innerHTML += `<span title="${outboundLinkTitle}">${outboundLinkIcon}</span>`;
        }
    });
}
document.addEventListener('DOMContentLoaded', outboundLinks);


// Marks links opening in a new tab or window
function newWindowLinks() {
    const html = document.querySelector('html');
    const lang = html.getAttribute('lang');

    const newWindowLinkTitle = lang === 'en' ? "Link opens new tab or window" : 'Odkaz otevře stránku v novém okně';
    const newWindowLinkSelector = 'a[target="_blank"]';
    const newWindowLinkIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.842 20.842"><g stroke-linecap="round" stroke-width="3"><path style="isolation:auto;mix-blend-mode:normal;solid-color:#000;solid-opacity:1" overflow="visible" d="M4.5.5h15.842v15.842H4.5z"/><path style="isolation:auto;mix-blend-mode:normal;solid-color:#000;solid-opacity:1" overflow="visible" fill="#fff" d="M.5 4.5h15.842v15.842H.5z"/></g></svg>';

    document.querySelectorAll(newWindowLinkSelector).forEach(link => {
        const existingTitle = link.getAttribute('title') || '';
        const newLine = existingTitle !== '' ? '\n' : '';
        link.setAttribute('title', existingTitle + newLine + newWindowLinkTitle);
        link.classList.add('new-window-link');

        if (!link.querySelector('img')) {
            link.innerHTML += `<span title="${newWindowLinkTitle}">${newWindowLinkIcon}</span>`;
        }
    });
}
document.addEventListener('DOMContentLoaded', newWindowLinks);


// Changes node position in HTML structure according to its usage (basic position in the baseWrapper or mobile boxed in the mobileWrapper)
function nodeToggle(baseWrapper, mobileWrapper, node, forceReset) {
    baseWrapper = document.querySelector(baseWrapper);
    mobileWrapper = document.querySelector(mobileWrapper);
    node = document.querySelector(node);

    var destNode = (baseWrapper.contains(node)) ? mobileWrapper : baseWrapper;

    if (forceReset) destNode = baseWrapper;

    destNode.appendChild(node);
}


// Resets node position in HTML structure according to viewport width (to the basic desktop position)
function nodeMqCheck(baseWrapper, mobileWrapper, node) {
    var mq = window.matchMedia('screen and (min-width: 900px)'),
        box = document.querySelector(mobileWrapper);
    var runScript = function() {
        nodeToggle(baseWrapper, mobileWrapper, node, 1);
        box.classList.remove('is-visible');
        document.body.classList.remove("noscroll");
        mq.removeEventListener('change', runScript);
    }
    var checkMediaQuery = function() {
        if (mq.matches) {
            runScript(mq);
        } else {
            mq.addEventListener('change', runScript);
        }
    }
    checkMediaQuery(mq);
}


// Removes highlight effect of defined elements (using css selector)
function removeHighlight(selector) {
    var objects = document.querySelectorAll(selector);
    for (let i = 0; i < objects.length; ++i) {
        objects[i].classList.remove('highlight');
    }
}


// Set of functions to deal with main menu on mobile
function mobileMenuManagement() {
    menuSublistToggle();

    nodeToggle('.menu-base', '.menu-box', '.menu-list');
    noscrollToggle();
    nodeMqCheck('.menu-base', '.menu-box', '.menu-list');
    updateNavAria('.menu-list', '.menu-base', '#menu-box', 'Menu');
    updateButtonAria('#menu-show', '#menu-box', true);
}

// Handles responsive skip-link target based on viewport width.
function setupSkipLinkTarget(selector, desktopHref, mobileHref) {
    const skipLink = document.querySelector(selector);
    if (!skipLink) return;

    const mq = window.matchMedia('(min-width: 900px)');
    const updateHref = () => {
        skipLink.setAttribute('href', mq.matches ? desktopHref : mobileHref);
    };

    updateHref();
    mq.addEventListener('change', updateHref);
}

document.addEventListener('DOMContentLoaded', () => {
    setupSkipLinkTarget('.nav-access--main-menu a', '#menu-list', '#menu-box');
    setupSkipLinkTarget('.nav-access--eshop-tree a', '#nav-tree', '#tree-box');
});


// Handles responsive menu accessibility attributes
function updateNavAria(targetSelector, primarySelector, secondarySelector, defaultFallback) {
    const target = document.querySelector(targetSelector);
    const primary = document.querySelector(primarySelector);
    const secondary = document.querySelector(secondarySelector);
    if (!target || !primary || !secondary) return;

    const defaultLabel = primary.getAttribute('data-aria-label') || defaultFallback;

    if (primary.contains(target)) {
        primary.setAttribute('aria-hidden', 'false');
        primary.setAttribute('aria-label', defaultLabel);
        secondary.setAttribute('aria-hidden', 'true');
        secondary.removeAttribute('aria-label');
    } else if (secondary.contains(target)) {
        secondary.setAttribute('aria-hidden', 'false');
        secondary.setAttribute('aria-label', defaultLabel);
        primary.setAttribute('aria-hidden', 'true');
        primary.removeAttribute('aria-label');
    }
}

(function() {
    let resizeTimer;
    const refreshNavAria = () => {
        updateNavAria('.menu-list', '.menu-base', '#menu-box', 'Menu');
        updateNavAria('.nav-tree', '.eshop-submenu-box', '#tree-box', 'Eshop menu');
        updateNavAria('.nav-tree', '.tree-base', '#tree-box', 'Eshop menu');
    };

    // window.addEventListener('DOMContentLoaded', refreshNavAria);
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(refreshNavAria, 100);
    });
})();


// Handles button aria-expanded based on container's is-visible class
function updateButtonAria(buttonSelector, containerSelector, reverseState = false) {
  const button    = document.querySelector(buttonSelector);
  const container = document.querySelector(containerSelector);
  if (!button || !container) return;
  const visible = container.classList.contains('is-visible');
  const expanded = reverseState ? !visible : visible;
  button.setAttribute('aria-expanded', expanded);
}

// Observes container's class attribute and keeps aria-expanded in sync
function setupBoxAriaObserver(buttonSelector, containerSelector, reverseState = false) {
  const button    = document.querySelector(buttonSelector);
  const container = document.querySelector(containerSelector);
  if (!button || !container) return;
  const observer = new MutationObserver(() => {
    updateButtonAria(buttonSelector, containerSelector, reverseState);
  });
  observer.observe(container, {
    attributes: true,
    attributeFilter: ['class']
  });
  updateButtonAria(buttonSelector, containerSelector, reverseState);
}

document.addEventListener('DOMContentLoaded', () => {
  // search box
  setupBoxAriaObserver('#search__icon',    '#search-box');
  // login box
  setupBoxAriaObserver('#login-expander',  '#header-login');
  // logged-in user box
  setupBoxAriaObserver('#logged-login-link','#header-logged');
});


// Toggles visibility of menu sublists
function menuSublistToggle() {
    var sublistButtons = document.getElementsByClassName('sublist__expander');

    for (let i = 0; i < sublistButtons.length; ++i) {
        let sublistButton = sublistButtons[i],
            sublist = sublistButton.parentElement;

        sublistButton.addEventListener('click', function(event) {
            event.preventDefault();
            sublist.classList.toggle('open-sublist');
        });
    }
}

// Set of functions to deal with eshop tree navigation on mobile
/* function mobileTreeManagement() {} */
// Placed directly in html code due to deferred loading of css and js assets.
// Script also available in /js/mobileTreeManagement.js.


// Changes media query of nav-tree.css loaded with head link tag
function changeNavTreeMq() {
    var object = document.getElementById('nav-tree-css');
    if (object) {
        object.media = 'all';
    }
}


// Removes highlight effect in search process
function removeSearchHighlight() {
    removeHighlight('.search__icon, .search-items');
}


// Expands all textareas when text vertically overflows
function autoexpandTextarea() {
    const heightLimit = 250; // Maximum height: 250px
    const textareas = document.getElementsByTagName('textarea');

    for (let i = 0; i < textareas.length; ++i) {
        let textarea = textareas[i];

        textarea.addEventListener("input", function() {
            this.style.height = ""; // Resets the height
            this.style.height = Math.min(this.scrollHeight + 2, heightLimit) + "px";
        });
    }
}
autoexpandTextarea();


// Initialize pcs input length check: add/remove 'pcs--long' class when value length > 3
function checkPcsLength(input) {
  if (input.value.length > 3) {
    input.classList.add('pcs--long');
  } else {
    input.classList.remove('pcs--long');
  }
}

function checkPcsLengthOnPage() {
  const newInputs = document.querySelectorAll('input.pcs:not([data-pcs-init])');
  newInputs.forEach(input => {
    checkPcsLength(input);
    input.addEventListener('input', () => checkPcsLength(input));
    input.setAttribute('data-pcs-init', 'true');
  });
}

checkPcsLengthOnPage();


// Pushes formSent event after newsletter registration form submit
function registerNewsletterGA(form, box) {
    if (isEmail(form.EMAIL.value) && form.osobniudaje.checked) { // formSent event prevention when invalid
        if (box == true) {
            dataLayer.push({
                'event': 'formSent',
                'form': 'newsletterBox'
            });
        } else {
            dataLayer.push({
                'event': 'formSent',
                'form': 'newsletterStranka'
            });
        }
    }
}


// Shows the password
var input_id;

function psw_toggle(input_id) {
    var x = document.getElementById(input_id);
    if (x.type === "password") {
        x.type = "text";
    } else {
        x.type = "password";
    }
}


// Deferred embed of the 3rd party content + setting YouTube privacy mode
function embedContent() {
    const eObjects = document.getElementsByClassName('data-src');

    for (let i = 0; i < eObjects.length; ++i) {
        let eObject = eObjects[i],
            eObject_src = eObject.dataset.src;

        eObject_src ? (eObject.src = eObject_src.replace('youtube.com', 'youtube-nocookie.com')) : console.log('Deferred embedding of the 3rd party content have failed.');
    }
}
window.onload = function() {
    embedContent();
};


// Shows internalTraffic Cookie Box
function checkInternalTraffic() {
    if (readCookie('internalTraffic') == 'true') {
        console.log("Internal traffic detected.");
        // prodlouzeni platnosti cookie
        createCookie('internalTraffic', 'true', 365);
        // zobrazeni bubliny
        var parent = document.getElementsByTagName('body')[0];
        var nextChild = document.getElementById('top');
        var itbox = document.createElement('div');
        itbox.innerHTML = '<div style="pointer-events: none; position: fixed; z-index: 99999999; bottom: 0; left: 0; display: inline-block; padding: .5rem;"><strong style="position: relative;z-index: 2;font-size: 12px;color: #00ff00;">Internal Traffic</strong><span style="background: #000; opacity: .62; display: block; width: 100%; height: 100%; position: absolute; left: 0; top: 0;"></span></div>';
        parent.insertBefore(itbox, nextChild);
    }
}

mainAfterReady = 1;